import { Briefcase, Building2, Heart, Mail } from 'lucide-react'
import Link from 'next/link'
import React from 'react'

const footerLinks = {
  Produto: [
    { label: 'Empregos', href: '/auth/register' },
    { label: 'Hospedagem', href: '/auth/register' },
    { label: 'Estacionamento', href: '/auth/register' },
    { label: 'Restaurantes', href: '/auth/register' },
  ],
  Empresa: [
    { label: 'Sobre nós', href: 'https://acheivagas.com.br/auth/em-breve' },
    { label: 'Como funciona', href: '/como-funciona' },
    { label: 'Blog', href: '/blog' },
    { label: 'Contato', href: 'https://acheivagas.com.br/auth/em-breve' },
    { label: 'Parcerias', href: 'https://acheivagas.com.br/auth/em-breve' },
  ],
  Legal: [
    { label: 'Termos de uso', href: '/legal/termos-de-uso' },
    { label: 'Privacidade', href: '/legal/politica-de-privacidade' },
  ],
}

export function Footer() {
  return (
    <footer className="bg-[#0a0f1c] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(37,99,235,0.08),transparent_60%)]" />
      <div
        className="absolute inset-0 opacity-[0.02] md:opacity-[0.03]"
        style={{
          backgroundImage: "url('https://www.transparenttextures.com/patterns/cubes.png')",
        }}
      />

      <div className="container mx-auto px-4 sm:px-6 relative">
        <div className="pt-12 md:pt-20 pb-8 md:pb-12 border-b border-white/5">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-8">
            <div className="col-span-2 md:col-span-4 lg:col-span-2">
              <div className="flex items-center gap-2.5 mb-4 md:mb-5">
                <div className="w-8 h-8 md:w-9 md:h-9 bg-gradient-to-br from-blue-500 to-violet-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-xs md:text-sm">A</span>
                </div>
                <div>
                  <h2 className="text-base md:text-lg font-bold leading-none">AcheiVagas</h2>
                  <span className="text-[8px] md:text-[10px] text-gray-500 tracking-wider uppercase">
                    .com.br
                  </span>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed mb-4 md:mb-6 max-w-sm text-sm">
                Plataforma inteligente de busca. Encontre empregos, hospedagem e muito mais com o
                poder da IA.
              </p>
              <div className="flex items-center gap-3 md:gap-4">
                <button
                  type="button"
                  className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"
                >
                  <Briefcase className="h-3.5 w-3.5 md:h-4 md:w-4 text-gray-400" />
                </button>
                <button
                  type="button"
                  className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"
                >
                  <Building2 className="h-3.5 w-3.5 md:h-4 md:w-4 text-gray-400" />
                </button>
                <button
                  type="button"
                  className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"
                >
                  <Mail className="h-3.5 w-3.5 md:h-4 md:w-4 text-gray-400" />
                </button>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h3 className="font-semibold text-sm uppercase tracking-wider text-gray-300 mb-3 md:mb-4">
                  {title}
                </h3>
                <ul className="space-y-2 md:space-y-3">
                  {links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-gray-500 hover:text-gray-300 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="py-4 md:py-5 border-b border-white/5">
          <p className="text-xs text-zinc-500 max-w-2xl mx-auto text-center">
            <strong>AcheiVagas é um meta-buscador.</strong> Indicamos vagas publicadas em portais
            terceiros. Não publicamos, armazenamos ou intermediamos vagas.{' '}
            <Link href="/como-funciona" className="underline hover:text-indigo-400">
              Como funciona
            </Link>
          </p>
        </div>

        <div className="py-5 md:py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[10px] md:text-xs text-gray-600 text-center sm:text-left">
            &copy; {new Date().getFullYear()} AcheiVagas.com.br. Todos os direitos reservados.
          </p>
          <p className="text-[10px] md:text-xs text-gray-600 flex items-center gap-1">
            Feito com <Heart className="h-3 w-3 text-red-500 fill-red-500" /> no Brasil
          </p>
        </div>
      </div>
    </footer>
  )
}
